import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './ui/table';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

/**
 * The promotion report's six aggregate tables differ only in their columns, so
 * they share one component driven by a column config.
 *
 * A column is `{ id, label, align, render(row) }`.
 */
export default function PromotionBreakdownTable({
  title,
  description,
  columns,
  rows = [],
  emptyMessage = 'No data for this period',
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </CardHeader>
      <CardContent>
        <div className="border rounded-md overflow-hidden">
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  {columns.map((column) => (
                    <TableHead
                      key={column.id}
                      style={{ whiteSpace: 'nowrap', padding: '8px 12px' }}
                      className={
                        column.align === 'right' ? 'text-right' : 'text-left'
                      }
                    >
                      {column.label}
                    </TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      className="text-center py-8"
                    >
                      {emptyMessage}
                    </TableCell>
                  </TableRow>
                ) : (
                  rows.map((row, index) => (
                    <TableRow
                      key={row.rowKey || index}
                      className={`hover:bg-muted/70 transition-colors ${
                        index % 2 === 0 ? 'bg-background' : 'bg-muted/20'
                      }`}
                    >
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          style={{ padding: '8px 12px' }}
                          className={
                            column.align === 'right'
                              ? 'text-right'
                              : 'text-left'
                          }
                        >
                          {column.render(row)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
